import { render, staticRenderFns } from "./ClicNavBarBrand.vue?vue&type=template&id=245c314e&"
import script from "./ClicNavBarBrand.vue?vue&type=script&lang=js&"
export * from "./ClicNavBarBrand.vue?vue&type=script&lang=js&"
import style0 from "./ClicNavBarBrand.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports